"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _forEach = _interopRequireDefault(require("lodash/forEach"));
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _chartist = _interopRequireDefault(require("chartist"));
var _dom = _interopRequireDefault(require("@spothero/utils/dom"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class Chart extends _react.Component {
  static defaultProps = {
    aspectRatio: 'double-octave'
  };
  constructor(props) {
    super(props);
    if (window) {
      const {
        type,
        options,
        legend,
        tooltip
      } = props;
      const plugins = [];
      const isDonut = type === 'Donut';
      this._chartType = isDonut ? 'Pie' : type;
      this._options = {
        ...options
      };
      if (isDonut) {
        this._options.donut = true;
      }
      if (legend) {
        plugins.push(_chartist.default.plugins.legend(legend));
      }
      if (tooltip) {
        plugins.push(_chartist.default.plugins.tooltip(tooltip));
      }
      if (this._options.plugins) {
        this._options.plugins.concat(plugins);
      } else {
        this._options.plugins = plugins;
      }
      this._previousOptions = this._options;
    }
  }
  componentDidMount() {
    if (window) {
      const {
        data,
        responsiveOptions,
        events
      } = this.props;
      this._chartist = new _chartist.default[this._chartType](this._chart, data, this._options, responsiveOptions);
      if (events) {
        (0, _forEach.default)(events, ({
          event,
          handler
        }) => {
          this._chartist.on(event, handler);
        });
      }
    }
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    const {
      data,
      options,
      responsiveOptions
    } = this.props;
    this._options = {
      ...this._options,
      ...options
    };
    if (window && !(0, _isEqual.default)(this._previousOptions, this._options)) {
      this._chartist.update(data, this._options, responsiveOptions);
      this._previousOptions = this._options;
    }
  }
  componentWillUnmount() {
    if (window) {
      const {
        tooltip,
        events
      } = this.props;
      if (tooltip && tooltip.appendToBody) {
        _dom.default.remove('.chartist-tooltip');
      }
      (0, _forEach.default)(events, ({
        event,
        handler
      }) => {
        this._chartist.off(event, handler);
      });
      this._chartist.detach();
    }
  }

  /**
   * Getter for the chartist event emitter.
   *
   * @public
   * @returns {Object} - The event emitter.
   */
  get eventEmitter() {
    return this._chartist.eventEmitter;
  }
  render() {
    if (!window) {
      return null;
    }
    const {
      className,
      aspectRatio
    } = this.props;
    const classes = (0, _classnames.default)('Chart', 'ct-chart', `ct-${aspectRatio}`, className);
    return /*#__PURE__*/_react.default.createElement("div", {
      ref: node => {
        this._chart = node;
      },
      className: classes
    });
  }
}
exports.default = Chart;